import Layout from "../components/Layout/Layout";

const Policy = () => {
  return <Layout title={"Privacy Policy"}>Privacy and Policy</Layout>;
};

export default Policy;
